import team1 from "../../Images/team-1.png";
import team2 from "../../Images/team-2.png";
import team3 from "../../Images/team-3.png";
import team4 from "../../Images/team-4.png";
import team5 from "../../Images/team-5.png";
import team6 from "../../Images/team-6.png";
import insta from "../../Images/Instagram.png";
import twitter from "../../Images/Twitter.png";
import facebook from "../../Images/Facebook.png";

export const TeamData = [
  {
    id: 1,
    name: "Alexa Boss",
    Title: "CEO and Founder",
    img: team1,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
  {
    id: 2,
    name: "Lizza Hessan",
    Title: "Therapist",
    img: team2,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
  {
    id: 3,
    name: "Martha Jax",
    Title: "Therapist",
    img: team3,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
  {
    id: 4,
    name: "David Truth",
    Title: "Massage Expert",
    img: team4,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
  {
    id: 5,
    name: "Jennifer Failr",
    Title: "Cosmetologist",
    img: team5,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
  {
    id: 1,
    name: "Nick Carman",
    Title: "Massage Expert",
    img: team6,
    social: [
      { icon: insta, path: "" },
      { icon: twitter, path: "" },
      { icon: facebook, path: "" },
    ],
  },
];
